import { render, staticRenderFns } from "./BellAuthEdit.vue?vue&type=template&id=44c8f99f&scoped=true&"
import script from "./BellAuthEdit.vue?vue&type=script&lang=js&"
export * from "./BellAuthEdit.vue?vue&type=script&lang=js&"
import style0 from "./BellAuthEdit.vue?vue&type=style&index=0&id=44c8f99f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c8f99f",
  null
  
)

export default component.exports